// extracted by mini-css-extract-plugin
module.exports = {"root":"IconReviewStar_root__3stOD","filled":"IconReviewStar_filled__3DiHT"};